import { z } from "zod";
// ----------------------------------------------------------------- client → server
export const SubscribeMsg = z.object({
    t: z.literal("subscribe"),
    sub: z.string().min(1).max(64),
    query: z.string().max(4000),
    /** 0 = count only (dashboard counters): no window, just `total` in snapshot / meta. */
    limit: z.number().int().min(0).max(1000).default(50),
});
export const UnsubscribeMsg = z.object({ t: z.literal("unsubscribe"), sub: z.string().min(1).max(64) });
export const PingMsg = z.object({ t: z.literal("ping") });
/** Follow card positions of one board; `unsubscribe` with the same `sub` stops it. */
export const BoardMsg = z.object({ t: z.literal("board"), sub: z.string().min(1).max(64), boardId: z.number().int() });
export const ClientMessage = z.discriminatedUnion("t", [SubscribeMsg, UnsubscribeMsg, PingMsg, BoardMsg]);
/** Close codes the server uses. 4xxx is the application range. */
export const CLOSE_UNAUTHORIZED = 4401;
export const CLOSE_OVERFLOW = 4429;
export const CLOSE_BAD_MESSAGE = 4400;
//# sourceMappingURL=protocol.js.map